import React, { useState } from 'react';
import axios from 'axios';
import './SendInviteCodeModal.css'; // We will create this CSS file next

const SendInviteCodeModal = ({ inviteCode, onClose }) => {
  const [recipientEmail, setRecipientEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleEmailChange = (e) => {
    setRecipientEmail(e.target.value);
  };

  const handleSendEmail = async () => {
    if (!recipientEmail) {
      setError('Recipient email is required.');
      return;
    }

    setSubmitting(true);
    setError('');
    setSuccess(false);

    try {
      const payload = {
        recipient_email: recipientEmail,
      };

      // Assuming the backend endpoint is POST /invite-codes/{invite_code_id}/send-email
      await axios.post(`${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/invite-codes/${inviteCode.id}/send-email`, payload);
      
      setSuccess(true);
      // Optionally close the modal after a delay or show a success message
      setTimeout(() => onClose(), 2000);

    } catch (err) {
      console.error('Error sending invite code email:', err);
      setError('Failed to send email. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Send Invite Code via Email</h2>
          <button className="modal-close-button" onClick={onClose}>×</button>
        </div>

        {success ? (
          <div className="modal-success">
            <p>Invite code email sent successfully!</p>
          </div>
        ) : (
          <div className="modal-content">
            <p>Sending invite code: <strong>{inviteCode.invite_code}</strong> to:</p>
            <div className="form-group">
              <label htmlFor="recipientEmail">Recipient Email</label>
              <input
                type="email"
                id="recipientEmail"
                value={recipientEmail}
                onChange={handleEmailChange}
                required
                placeholder="Enter recipient email"
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button 
              className="send-email-button"
              onClick={handleSendEmail}
              disabled={submitting}
            >
              {submitting ? 'Sending...' : 'Send Email'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SendInviteCodeModal; 